import React    from "react"
import ReactDOM from "react-dom"

import { ApolloProvider } from '@apollo/client'
import { MsalProvider } from '@azure/msal-react'
import { createStore, applyMiddleware, compose } from 'redux'
import { BrowserRouter as Router } from "react-router-dom"
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

import App      from "./App"
import reducers from './redux/reducers/index'
import { createApolloClient, setApolloClient } from './services/apolloClient'
import { AuthProvider } from './services/auth/AuthProvider'
import { getMsalInstance } from './services/auth/entraClient'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk)),
)

const apolloClient = createApolloClient()
setApolloClient(apolloClient)

const msalInstance = getMsalInstance()

const appTree = (
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <App />
        </Router>
      </AuthProvider>
    </Provider>
  </ApolloProvider>
)

ReactDOM.render(
  msalInstance ? <MsalProvider instance={msalInstance}>{appTree}</MsalProvider> : appTree,
  document.getElementById("root")
)
